import LabelProvider from "core/components/label/LabelProvider";
import courseLabels from "common/entities/courseWrapper/labels";

export default LabelProvider.create({
    ...courseLabels.getData(),
		RecommendedEmpty:{
			k: "recommended.empty.title",
			v: "No Recommended Courses Available"
	},
	RecommendedDescriptionEmpty:{
			k:"recommended.empty.description",
			v:""
	},
    RecommendedNotFoundTitle: {
		k: "recommended.notfound.title",
		v: "No Recommended Courses Available"
    },
    
    RecommendedNotFoundDesc: {
		k: "recommended.notfound.desc",
		v: ""
    },
    
    RecommendedNoUserTags: {
		k: "recommended.notfound.user.tags",
		v: ""
    },
    
    RecommendedPreferencesEditLabel: {
		k: "recommended.preferences.edit.label",
		v: "Edit"
	},
});



// WEBPACK FOOTER //
// ./src/panels/recommended/Recommended.labels.ts